<template>
  <div class="industrial">
    <div class="banner">
      <img
        src="../../static/img/cylbanner@2x.png"
        alt=""
      >
    </div>
    <div class="group_cont">
      <!-- 产业链 -->
      <div class="cyl cent">
        <div class="cyl_title">
          <h4>产业链</h4>
          <p>ABOUT INDUSTRY CHAIN</p>
        </div>
        <div class="cyl_txt">
          <div class="cyl_cont">
            <p>以科技创新为核心，引领新时代的互联网保险发展。</p>
            <p>用科技的手段帮助各个保险公司在财险，团险，个脸领域进行，成本调优，服务提升，客户体验感不断增强。</p>
            <p>用科技能力驱动保险中介业务的发展，在客户基本保障的基础上，帮其在健康，弹性福利等领域持续享受高质量的增值服务。</p>
          </div>
          <img
            src="../../static/img/产业链——科技创新@2x.png"
            alt=""
          >
        </div>
        <div class="cyl_title">
          <h4>子公司介绍</h4>
          <p>INTRODUCTION OF SUBSIDIARIES</p>
        </div>
        <div class="xhwb">
          <div class="xh_title">
            <h4>协和万邦</h4>
            <p>ABOUT XIE HE WAN BANG</p>
          </div>
          <div class="xh_cont">
            <p>协和万邦保险经纪有限公司成立于2008年，公司注册资金5000万。经过七年稳健、创新发展，目前正结合互联网思维，采用O2O模式，倾力打造以“飞猪保险”、“停有钱”项目为核心的金融服务平台，是一家具备全国代理资质的保险中介机构。</p>
          </div>
          <ul class="pic_xh">
            <li v-for="(item, i) in xhwb" :key="i">
              <div class="xhList">
                <span class="xfk"></span>
                <span>{{item.xhText}}</span>
                <span class="jia" id="img" @click="changeContent(i)">
                <img :src="item.img_1" alt="" @click="isSel(i)" v-if="active3">
               <img :src="item.img_1" @click="isSels(i)" v-if="active4">
                </span>
              </div>
              <div class="xhImg" v-show="item.showContent">
                <img :src="item.img_3" alt="">
                <div class="xhConts">
                  <span></span>
                  <h4>{{item.xhText}}</h4>
                  <p>{{item.xhCont}}</p>
                </div>
              </div>
            </li>
          </ul>
          <!-- 方胜磐石 -->
          <div class="xh_title">
            <h4>方胜磐石</h4>
            <p>ABOUT FANG SHENG PAN SHI</p>
          </div>
          <div class="xh_cont">
            <p>方胜馨石保险经纪有限公司是经中国保监会批准设立的一家全国性保险中介服务企业，2003年成立于北京，注册资本金5000万。两岸三地一线品牌四大股东强势重组，优势互补，横跨品牌价值、客户资源、营销技术、客户服务、IT科技等重要领域，为FESCO ROCK个险发展奠定基础！</p>
          </div>
          <ul class="pic_xh">
            <li v-for="(item, i) in fsCont" :key="i">
              <div class="xhList">
                <span class="xfk"></span>
                <span>{{item.fstext}}</span>
                <span class="jia" @click="changeContents(i)">
                  <!-- <img :src="item.img_1" alt=""> -->
                  <img :src="item.img_1" alt="" @click="isSel2(i)" v-if="active5">
                  <img :src="item.img_1" @click="isSel3(i)" v-if="active6">
                </span>
              </div>
              <div class="xhImg" v-show="item.showContent">
                <img :src="item.img_3" alt="">
                <div class="xhConts">
                  <span></span>
                  <h4>{{item.fstext}}</h4>
                  <p>{{item.fsCont}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      activeName: "0",
      active: null,
      active2: null,
      isShow: false,
      active3:true,
      active4:false,
      active5:true,
      active6:false,
      xhwb: [
        {
          xhText: "协和万邦的由来",
          xhCont:
            '协和万邦的观念第一次以下列的形式被表述出来："日若稽古，帝尧日放勋，钦明文思安安，允恭克让，光被四表，格于上下。克明俊德，以亲九族。九族既睦，平章百姓，百姓昭明，协和万邦，黎民于变时雍。"（《尚书·尧典》），这就是"协和万邦"。',
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/协和万邦的由来背景@2x.png"),
          showContent: false
        },
        {
          xhText: "协和万邦的愿景",
          xhCont: "成为全球领先的保险经纪公司",
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/协和万邦愿景背景@2x.png"),
          showContent: false
        },
        {
          xhText: "协和万邦的使命",
          xhCont:
            "五大责任： 第一：对公司负责；第二：对股东负责；第三：对客户负责；第四：对员工负责；第五：对社会负责。",
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/协和万邦使命背景@2x.png"),
          showContent: false
        },
        {
          xhText: "协和万邦的企业精神",
          xhCont:
            "诚信守法、团结进取、追求卓越、服务领先、创造价值、简单务实、不怕困难、积极进取、回馈社会、报效国家。",
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/协和万邦企业精神背景@2x.png"),
          showContent: false
        }
      ],
      fsCont: [
        {
          fstext: "方胜磐石的愿景",
          fsCont:
            "致力于打造一个提供客户全方位最贴心的保险咨询和保障服务,提供高端客户全面优质的保险理财产品服务,提供客户最好的健康保险保障服务,提供专业人才行业内最好的成长机遇,引领行业发展的全国性、全方位、专业型金融中介集团",
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/方胜磐石的愿景背景@2x.png"),
          showContent: false
        },
        {
          fstext: "方胜磐石的核心价值",
          fsCont: "诚信、专业、真情、合作、责任",
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/方胜磐石的核心价值背景@2x.png"),
          showContent: false
        },
        {
          fstext: "方胜磐石的三Q精神",
          fsCont: "品质、数量、专业资格",
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/方胜磐石的三Q精神背景@2x.png"),
          showContent: false
        },
        {
          fstext: "方胜磐石的经营原则",
          fsCont:
            "以财务稳健为基础，以诚信专业为核心，以提升员工素质为目标，以善尽社会公益为责任。用爱与关怀，建立-一个投资于人，相互信任，稳健经营，追求卓越的运营模式，创造真诚的保险服务，成为华人地区的领导品牌。",
          img_1: require("../../static/img/加号@2x.png"),
          img_2: require("../../static/img/叉号@2x.png"),
          img_3: require("../../static/img/方胜磐石的经营原则背景@2x.png"),
          showContent: false
        }
      ]
    };
  },
  mounted() {
     if(this.isMobile()) {
          this.$router.push({ path: "/industrial" });
        } else {
          this.$router.push({ path: "/cyl?page=2" });
        }
  },
  methods: {
    isSel (i) {
        if(i===i){
          this.active3 = false,
          this.active4 = true
          this.xhwb[i].img_1 = require("../../static/img/叉号@2x.png")
        }
      },
    isSels (i) {
        if(i===i){
          this.active3 = true,
          this.active4 = false
          this.xhwb[i].img_1 = require("../../static/img/加号@2x.png")
        }
      },
    isSel2 (i) {
        if(i===i){
          this.active5 = false,
          this.active6 = true
          this.fsCont[i].img_1 = require("../../static/img/叉号@2x.png")
        }
      },
    isSel3 (i) {
        if(i===i){
          this.active5 = true,
          this.active6 = false
          this.fsCont[i].img_1 = require("../../static/img/加号@2x.png")
        }
      },

    changeContent(i) {
      var temp = this.xhwb;
      temp[i].showContent = !temp[i].showContent;
      this.xhwb = temp;
    },
    changeContents(i) {
      var temp = this.fsCont;
      temp[i].showContent = !temp[i].showContent;
      this.fsCont = temp;
    },
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
};
</script>
<style lang="scss" scoped>
.cent {
  margin: 0 auto;
  width: 92%;
}
.banner {
  width: 100%;
  height: 3.4rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.group_cont {
  .cyl {
    font-size: 0.28rem;
    color: #676e74;
    .cyl_title {
      padding: 0.2rem 0;
      text-align: center;
      h4 {
        color: #0250a4;
        font-weight: 600;
        line-height: 0.45rem;
        font-size: 0.28rem;
      }
      p {
        font-size: 0.22rem;
        color: #848a90;
      }
    }
    .cyl_txt {
      padding: 0.3rem 0;
      display: flex;
      justify-content: space-between;
      .cyl_cont {
        width: 3.55rem;
        padding-right: 0.05rem;
        p {
          text-indent: 2em;
          font-size: 0.26rem;
          line-height: 0.4rem;
        }
      }
      img {
        display: inline-block;
        width: 3.19rem;
        height: 4.04rem;
      }
    }
    .xhwb {
      padding: 0.2rem 0;
      .xh_title {
        padding-top: 0.2rem;
        h4 {
          font-size: 0.26rem;
          color: #e10f24;
          font-weight: 600;
          line-height: 0.32rem;
        }
        p {
          font-size: 0.1rem;
          color: #413f44;
        }
      }
      .xh_cont {
        p {
          padding: 0.3rem 0;
          text-indent: 2em;
          font-size: 0.26rem;
          color: #898a8c;
          line-height: 0.4rem;
        }
      }
      .pic_xh {
        padding: 0.2rem 0;
        li {
          .xhList {
            height: 0.6rem;
            line-height: 0.6rem;

            color: #4c75b3;
            border-bottom: 2px solid #02509e;
            position: relative;
            .xfk {
              display: inline-block;
              width: 0.15rem;
              height: 0.15rem;
              background-color: #044d99;
              position: absolute;
              top: 50%;
            }
            span:nth-child(2) {
              display: inline-block;
              padding-left: 0.3rem;
              width: 3rem;
            }
            .jia {
              display: inline-block;
              width: 0.16rem;
              height: 0.16rem;
              position: absolute;
              right: 0.2rem;
              top: 30%;
            }
          }
          .xhImg {
            height: 3.68rem;
            padding: 0 0.25rem;
            position: relative;
            img {
              position: absolute;
              top: 0;
              display: block;
              height: 100%;
            }
            .xhConts {
              position: absolute;
              top: 0;
              padding: 0.3rem 0.6rem;
              z-index: 2;
              color: #fefef8;
              span {
                width: 0.8rem;
                height: 0.05rem;
                background-color: #fff;
                display: block;
              }
              h4 {
                font-size: 0.28rem;
                padding: 0.3rem 0;
              }
              p {
                font-size: 0.24rem;
                line-height: 0.34rem;
                // padding: .1rem 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Industrial.vue